import type { ReactElement } from 'react';
/**
 * A busy indicator that announces itself.
 *
 * `role="status"` with a real label rather than a bare spinning div: a screen
 * reader user otherwise gets silence, which is indistinguishable from a broken
 * page. `aria-hidden` on the visual so the label is not read twice.
 */
export function Spinner({ label = 'Loading' }: { label?: string }): ReactElement {
  return (
    <span role="status" className="inline-flex items-center gap-2 text-muted">
      <span
        aria-hidden="true"
        className="size-4 shrink-0 animate-spin rounded-full border-2 border-current border-t-transparent"
      />
      {/* Rendered even when empty: `<Button loading>` passes "" so the spinner
          adds no second name to a button whose label already says what it is
          doing, and the element still carries the live region. */}
      <span className="text-[length:var(--text-sm)] empty:hidden">{label}</span>
    </span>
  );
}
